/**
 * 프로젝트 차원 소수점 처리 정책: 반올림(round) 금지, **버림(truncate, 0 방향 절단)** 사용.
 * 화면 표시·파일 export·DXF/CSV/TXT 라벨 등 사용자 가시 영역에서 자릿수를 적용할 때
 * `value.toFixed()` 직접 호출 대신 본 모듈을 사용한다.
 *
 * 음수는 0 방향으로 잘린다 (`-1.239` → `-1.23`). trailing zero 는 보장된다 (`12.3` → `"12.30"`).
 */

function truncateToFractionDigits(value: number, fractionDigits: number): number {
  const factor = 10 ** fractionDigits;
  return Math.trunc(value * factor) / factor;
}

/**
 * 숫자를 지정된 자릿수에서 버림하여 고정 자릿수 문자열로 반환한다.
 * 입력은 유한 number 여야 한다 (`NaN`/`Infinity` 보호 필요 시 `truncateNumberSafe` 사용).
 */
export function truncateNumber(value: number, fractionDigits: number): string {
  return truncateToFractionDigits(value, fractionDigits).toFixed(fractionDigits);
}

/**
 * null / undefined / NaN / Infinity 안전 버전. 유효하지 않은 입력은 `fallback` (기본 "-") 반환.
 * `0` 은 유효한 숫자로 취급하여 `"0.00"` 형태로 반환한다.
 */
export function truncateNumberSafe({
  value,
  fractionDigits,
  fallback = "-",
}: {
  value: number | null | undefined;
  fractionDigits: number;
  fallback?: string;
}): string {
  if (value === null || value === undefined) return fallback;
  if (typeof value !== "number" || !Number.isFinite(value)) return fallback;
  return truncateNumber(value, fractionDigits);
}
